import { atom } from "recoil";
import { PaymentRemittanceTypeInfo } from "../types";

export const addStatePaymentRemittanceType = atom({
  key: "addStatePaymentRemittanceType",
  default: false,
});
export const editStatePaymentRemittanceType = atom({
  key: "editStatePaymentRemittanceType",
  default: false,
});
export const rowEditIdStatePaymentRemittanceType = atom({
  key: "rowEditId",
  default: null,
});
export const disableButtonStatePaymentRemittanceType = atom({
  key: "disableButtonStatePaymentRemittanceType",
  default: false,
});

export const selectedRowsStatePaymentRemittanceType = atom<PaymentRemittanceTypeInfo[]>({
  key: "selectedRowsStatePaymentRemittanceType",
  default: [],
});

export const filterText = atom({
  key: "setFilterTextState",
  default: "",
});

export const selectedRowsToDelete = atom< undefined | []>({
  key: "selectedRowsToDelete",
  default: [],
});

export const rowForEditPaymentRemittanceType = atom<PaymentRemittanceTypeInfo | undefined>({
  key: "rowForEditPaymentRemittanceType",
  default: undefined,
});

export const paymentRemittanceTypeSaving = atom({
  key: "PaymentRemittanceTypeSaving",
  default: false,
});